import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  const { t } = useLang();
  return (
    <>
      <Seo title="404 | EMME SERVICE CAR" description={t.notFound.text} path="/404" />
      <section className="flex min-h-[80vh] items-center justify-center bg-carbon px-6 pt-24">
        <div className="text-center">
          <p className="font-display text-8xl font-extrabold text-amber">404</p>
          <h1 className="mt-4 font-display text-2xl font-bold text-ice">{t.notFound.title}</h1>
          <p className="mx-auto mt-3 max-w-sm text-sm text-steel">{t.notFound.text}</p>
          <Link
            to="/"
            data-testid="notfound-home-btn"
            className="mt-8 inline-flex items-center justify-center rounded-md bg-amber px-6 py-3 font-display text-sm font-bold uppercase text-carbon hover:bg-amber/90"
          >
            {t.notFound.back}
          </Link>
        </div>
      </section>
    </>
  );
}
